import React from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '../../../../contexts/ThemeContext';
import Profile from './Profile';

function HeaderContent() {
  const { theme } = useTheme();
  const user = useSelector((s) => s.auth.user);

  return (
    <div style={styles.wrapper}>
      <span style={{ color: theme.textSecondary, fontSize: '0.85rem', fontWeight: 600, marginRight: 12 }}>
        {user?.name || ''}
      </span>
      <Profile />
    </div>
  );
}

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
};

export default HeaderContent;
